import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../user/user.service';
import { Role } from '../common';
import { ApportisHubService } from '../apportis.hub.service';
import { Router } from '@angular/router';
import { PatientService } from '../patient/patient.service';
import { Constants } from '../app.constants';
import { MsgBoxComponent } from '../common/msg-box/msg.box.component';
import { WaitingRoomService } from '../waiting-room/waiting-room.service';
import { CheckinService } from '../checkin/checkin.service';
import { DatePipe } from '@angular/common';
import { TranslateOrgSpecificPipe } from '../common/pipes/translate-org-specific.pipe';
import { NotifierService } from 'angular-notifier';
import { ConfirmPopupInfo } from './confirm-popup-info';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmBoxComponent } from '../common/confirm-box/confirm-box.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public showCheckIn = false;
  public waiting_room_CheckIn = false;
  public orgType: any;
  public waitingRoomType;
  public objAppt: any = {};
  private patientLat;
  private patientLng;
  @ViewChild('msgbox') msgbox: MsgBoxComponent;
  isSidenavActive = false;
  public roleMenuitems;
  public isMenu = false;
  public allMenuItems: any[];
  patientname: any;
  clinicianName: any;
  sessionId: any;
  waitingRoomId: any;
  clinicianId: any;
  patientId: any;
  ClientLabel: string = Constants.Client;
  ClinicianLabel: string = Constants.Clinician;
  is_caa = false;
  isUniversity = false;
  is_enable_covid_tracking = false;
  dbSessionId: any;
  isReconnect = false;
  isTimer: any;
  confirmPopupInfo = new ConfirmPopupInfo();
  modalOption: NgbModalOptions = {};
  modelReference: any = [];
  orgName: string;
  role: string;
  isEnableReferal = false;

  constructor(private userService: UserService
    , private apportisHubservice: ApportisHubService
    , private patientService: PatientService
    , private router: Router
    , private waitingRoomService: WaitingRoomService
    , private checkinService: CheckinService
    , public datepipe: DatePipe
    , private translateOrgSpecific: TranslateOrgSpecificPipe
    , private notifier: NotifierService
    , private modalService: NgbModal
  ) { }

  ngOnInit() {


    let connected: any;
    connected = this.apportisHubservice.connected.subscribe((status) => {
      if (status && this.apportisHubservice.connection) {

        // Connect appointment
        this.apportisHubservice.connection.on('clinicianCheckedIn', (data: any) => {

          this.confirmPopupInfo = new ConfirmPopupInfo();
          this.confirmPopupInfo.isReconnect = false;
          if (data) {
            this.confirmPopupInfo.sessionId = data.sessionId;
            this.confirmPopupInfo.clinicianId = data.clinicianId;
            this.confirmPopupInfo.patientId = data.patientId;
            this.confirmPopupInfo.clinicianName = data.clinicianName;
            const appDt = this.datepipe.transform(new Date(data.appointmentDt), 'M/d/yy');
            this.confirmPopupInfo.appointmentDt = new Date(appDt + ',' + data.startTime);
            this.confirmPopupInfo.appointmentId = data.appointmentId;
            this.confirmPopupInfo.isReconnect = false;
            this.confirmPopupInfo.timerOff = false;
            this.role = data.roleName;
            if (this.apportisHubservice.isConnected) {
              navigator.geolocation.getCurrentPosition(this.geoPosition.bind(this), () => {
                this.geoPosition(null);
              }, { timeout: 3000 });
            } else {
              this.msgbox.alert(this.translateOrgSpecific.transform('ConnectionNotEstablishedMsg'), '');
            }
          } else {
            this.msgbox.alert(this.translateOrgSpecific.transform('ClientNotAvailableThisTime'), '');
          }
        });

        // reconnecting appointment
        this.apportisHubservice.connection.on('PatientReconnectToClinicianAppointment', (sessionId: any, clinicianId: any, patientId: any, name: any, dbSessionId: any, objAppt: any) => {
          const currentUrl = this.router.url;
          this.confirmPopupInfo = new ConfirmPopupInfo();
          this.confirmPopupInfo.patientId = objAppt.patientId;
          this.confirmPopupInfo.patientname = name;
          this.confirmPopupInfo.appointmentId = objAppt.appointmentId;
          this.confirmPopupInfo.sessionId = sessionId;
          this.confirmPopupInfo.dbSessionId = dbSessionId;
          const appDt = this.datepipe.transform(new Date(objAppt.appointmentDt), 'M/d/yy');
          this.confirmPopupInfo.appointmentDt = new Date(appDt + ',' + objAppt.startTime);
          this.confirmPopupInfo.timerOff = false;
          this.confirmPopupInfo.latitude = objAppt.latitude;
          this.confirmPopupInfo.longitude = objAppt.longitude;

          if (this.checkSameSession(dbSessionId, this.ClinicianLabel) == false) {
            let modalRef = null;
            this.setUpModel();

            modalRef = this.modalService.open(ConfirmBoxComponent, this.modalOption);
            modalRef.componentInstance.data = { message: this.translateOrgSpecific.transform(this.ClientLabel) + ' (' + this.confirmPopupInfo.patientname + ') has been trying to reconnect you for the appointment scheduled at ' + this.datepipe.transform(new Date(this.confirmPopupInfo.appointmentDt), 'MMM d, y h:mm:ss a') + '. Do you want to check-in now?', user: this.ClinicianLabel, popupdata: this.confirmPopupInfo };

            this.modelReference.push({ model: modalRef, userId: this.confirmPopupInfo.patientId });

            modalRef.result.then((result) => {
              if (result) {
                this.modelReference = this.modelReference.filter(x => x.userId != result.data.patientId);
                if (result.result == 'Confirm') {
                  this.confirmReconnectAppointmentByClinician(result.data);
                } else if (result.result == 'Snooze') {
                  this.snooze(result.data);
                } else if (result.result == this.translateOrgSpecific.transform('Timeout')) {
                  this.patientService.noResponseFromClinician(result.data.patientId, true).subscribe((info: any) => {
                  });
                }
              }

            });
          }
        });


        this.apportisHubservice.connection.on('waitingRoomCheckedIn', (objAppt: any, name: any, is_update: any) => {
          if (objAppt) {
            this.patientname = name;
            if (!is_update) {
              this.waiting_room_CheckIn = true;
              setTimeout(() => {
                this.waiting_room_CheckIn = false;
              }, 5000);
            } else {
              this.waiting_room_CheckIn = false;

            }
          }
        });

        // clinician disconnected
        this.apportisHubservice.connection.on('ClinicianDisconnect', (objResult: any, isAppointment: any, sessionId: any, userId: any, roleName: any) => {
          if (objResult) {
            this.modelReference.forEach(element => {
              if (element.userId == userId) {
                element.model.close();
                this.notifier.notify('error', 'Your call is being disconnected, ' + this.translateOrgSpecific.transform(roleName) + ' will again try to reach you after sometimes');
              }
            });
            this.modelReference = this.modelReference.filter(x => x.userId != userId);
          }
        });


        // client disconnected
        this.apportisHubservice.connection.on('ClientDisconnect', (objResult: any, isAppointment: any, sessionId: any, userId: any) => {
          if (objResult) {
            const currentUrl = this.router.url;
            if (!currentUrl.includes('clinicianvideo/casemanagement/show') && !currentUrl.includes('clinicianvideo/show')) {
              this.modelReference.forEach(element => {
                if (element.userId == userId) {
                  element.model.close();
                  this.notifier.notify('error', 'Your call is being disconnected by the ' + this.translateOrgSpecific.transform(this.ClientLabel) + '. Please reconnect again');
                }
              });
              this.modelReference = this.modelReference.filter(x => x.userId != userId);
            }
          }
        });


        // clinician confirm to patient waiting room reconnecting
        this.apportisHubservice.connection.on('patientReconnectWaitingRoom', (sessionId: any, patientId: any, clinicianId: any, waitingRoomId: any, dbSessionId: any, latitude: any, longitude: any, clientName: any) => {
          const currentUrl = this.router.url;
          this.confirmPopupInfo = new ConfirmPopupInfo();
          this.confirmPopupInfo.sessionId = sessionId;
          this.confirmPopupInfo.clinicianId = clinicianId;
          this.confirmPopupInfo.waitingRoomId = waitingRoomId;
          this.confirmPopupInfo.patientId = patientId;
          this.confirmPopupInfo.longitude = longitude;
          this.confirmPopupInfo.latitude = latitude;
          this.confirmPopupInfo.patientname = clientName;
          this.confirmPopupInfo.dbSessionId = dbSessionId;
          this.confirmPopupInfo.timerOff = false;
          if (this.checkSameSession(dbSessionId, this.ClinicianLabel) == false) {
            let modalRef = null;
            this.setUpModel();

            modalRef = this.modalService.open(ConfirmBoxComponent, this.modalOption);
            modalRef.componentInstance.data = { message: this.translateOrgSpecific.transform(this.ClientLabel) + ' (' + this.confirmPopupInfo.patientname + ') has been trying to reconnect you to the waiting room. Do you want to check-in now?', user: this.ClinicianLabel, popupdata: this.confirmPopupInfo };

            this.modelReference.push({ model: modalRef, userId: this.confirmPopupInfo.patientId });

            modalRef.result.then((result) => {
              if (result) {
                this.modelReference = this.modelReference.filter(x => x.userId != result.data.patientId);
                if (result.result == this.translateOrgSpecific.transform('Confirm')) {
                  this.ConfirmReconnectingWaitingRoomByClinician(result.data);
                } else if (result.result == this.translateOrgSpecific.transform('Snooze')) {
                  this.ClinicianSnoozeReconnectingCall(result.data);
                } else if (result.result == this.translateOrgSpecific.transform('Timeout')) {
                  this.patientService.noResponseFromClinician(result.data.patientId, false).subscribe((info: any) => {
                  });
                }
              }

            });
          }
        });


        // clinician trying to reconnect
        this.apportisHubservice.connection.on('clinicianReconnectToPatientAppointment', (sessionId: any
          , patientId: any, clinicianId: any, clinicianName: any, dbSessionId: any, objappt: any, roleName: any) => {
          const currentUrl = this.router.url;
          this.confirmPopupInfo = new ConfirmPopupInfo();
          this.confirmPopupInfo.sessionId = sessionId;
          this.confirmPopupInfo.clinicianId = clinicianId;
          this.confirmPopupInfo.patientId = patientId;
          this.confirmPopupInfo.clinicianName = clinicianName;
          this.confirmPopupInfo.appointmentDt = objappt.appointmentDt + ' ' + objappt.startTime;
          this.confirmPopupInfo.appointmentId = objappt.appointmentId;
          this.confirmPopupInfo.dbSessionId = dbSessionId;
          this.confirmPopupInfo.isReconnect = true;
          this.confirmPopupInfo.timerOff = false;
          this.role = roleName;
          if (this.apportisHubservice.isConnected) {
            navigator.geolocation.getCurrentPosition(this.geoPosition.bind(this), () => {
              this.geoPosition(null);
            }, { timeout: 3000 });
          } else {
            this.msgbox.alert(this.translateOrgSpecific.transform('ConnectionNotEstablishedMsg'), '');
          }
        });
        this.clinicianCheckedInWaitingRoom();
        if (connected) {
          connected.unsubscribe();
        }
      }
    });
  }

  checkSameSession(sessionId, userRole) {
    let result = false;
    const currentUrl = this.router.url;
    let s_id = this.userService.getSessionStorageItem('SessionId');
    s_id = s_id == undefined ? '0' : s_id;
    if (userRole == Constants.Client || userRole == Constants.Participants) {
      if (currentUrl.includes('clientvideo/show') && Number(sessionId) == Number(s_id)) {
        result = true;
      }
    } else {
      if ((currentUrl.includes('clinicianvideo/casemanagement/show') || currentUrl.includes('clinicianvideo/show')) && Number(sessionId) == Number(s_id)) {
        result = true;
      }
    }
    return result;
  }

  public snooze(details) {
    this.patientService.clinicianSnoozeAppointment(details.patientId).subscribe((info: any) => {
    });
  }


  confirmWaitingRoomCheckIn() {
    this.waiting_room_CheckIn = false;
  }

  userInfoLoaded(userInfo) {
    this.orgName = userInfo.orgName;
    const _this = this;
    this.userService.CurrentUser = userInfo;
    if (userInfo.isCaseManagement) {
      this.ClientLabel = Constants.Participants;
      this.ClinicianLabel = Constants.CaseManager;
      this.is_caa = true;
    }
    this.is_enable_covid_tracking = userInfo.isCovidTracking;
    this.isEnableReferal = userInfo.isEnableReferal ? userInfo.isEnableReferal : false;
    if (userInfo.orgType == Constants.University || userInfo.orgType == Constants.School) {
      this.isUniversity = true;
    }
    this.isMenu = true;
    const obj = this.userService.getSessionItem(Constants.OrgSpecificResource);
    this.initializeMenu();
    this.roleMenuitems = this.allMenuItems.filter(function (item) {
      if (item.role == '') {
        return item;
      }
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (item.role.indexOf(userInfo.roles[i]) > -1) {
          if (item.label == 'Waiting Room') {
            if (userInfo.orgType != Constants.Opi_org && userInfo.waitingRoomType != Constants.None) {
              return item;
            }
          } else if (item.label == _this.translateOrgSpecific.transform('Families') && _this.isUniversity == true) {
            return item;
          } else if (item.label == _this.translateOrgSpecific.transform('Families') && _this.isUniversity == false) {
            return null;
          } else if (userInfo.roles[i] == Constants.Cliadmin && item.label == 'Appointments' && userInfo.isCaseManagement) {
            return null;
          } else if (item.label == _this.translateOrgSpecific.transform('Tools')) {
            if (_this.isEnableReferal == true) {
              return item;
            } else {
              return null;
            }
          } else {
            return item;
          }
        }

      }
    });
  }
  public confirmCheckIn() {
    this.showCheckIn = false;
    const _this = this;
    _this.userService.appointmentId = _this.objAppt.appointmentId;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': { lat: _this.objAppt.latitude, lng: _this.objAppt.longitude } }, function (results, status) {
      let zipcode = '';
      let county = '';
      if (results[1]) {
        for (let i = 0; i < results.length; i++) {
          if (results[i].types[0] === 'postal_code') {
            zipcode = results[i].address_components[0].long_name;
          }
          if (results[i].types[0] === 'administrative_area_level_2') {
            county = results[i].address_components[0].long_name;
          }
        }
      } else {
        zipcode = '';
        county = '';
      }
      // call the method for insert session
      const session = {
        appointmentId: _this.objAppt.appointmentId,
        patientId: _this.objAppt.patientId,
        clinicianId: 0,
        anonymousUserId: 0,
        latitude: _this.objAppt.latitude,
        longitude: _this.objAppt.longitude,
        ipAddress: _this.objAppt.ip,
        browserType: _this.objAppt.browserType,
        secretCode: 0
      };
      _this.patientService.insertSession(session).subscribe((res: any) => {
        _this.userService.getUserLicenceNumberandName().subscribe((data) => {
          if (data) {
            const name = data.firstName + ' ' + data.lastName;
            if (_this.is_caa) {
              _this.router.navigate(['/clinicianvideo/casemanagement/show', _this.objAppt.sessionId, 0, res.sessionId, res.secretCode, _this.objAppt.patientId, zipcode, county, name, _this.objAppt.appointmentId]);
            } else {
              _this.router.navigate(['/clinicianvideo/show', _this.objAppt.sessionId, 0, res.sessionId, res.secretCode, _this.objAppt.patientId, zipcode, county, name, _this.objAppt.appointmentId]);
            }
          }
        });
      });
    });
  }

  confirmReconnectAppointmentByClinician(details) {
    const currentUrl = this.router.url;
    const _this = this;
    _this.userService.appointmentId = details.appointmentId;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': { lat: details.latitude, lng: details.longitude } }, function (results, status) {
      let zipcode = '';
      let county = '';
      if (results[1]) {
        for (let i = 0; i < results.length; i++) {
          if (results[i].types[0] === 'postal_code') {
            zipcode = results[i].address_components[0].long_name;
          }
          if (results[i].types[0] === 'administrative_area_level_2') {
            county = results[i].address_components[0].long_name;
          }
        }
      } else {
        zipcode = '';
        county = '';
      }
      _this.userService.getUserLicenceNumberandName().subscribe((data) => {
        if (data) {
          const name = data.firstName + ' ' + data.lastName;
          if (currentUrl.includes('clinicianvideo/casemanagement/show') || currentUrl.includes('clinicianvideo/show')) {
            _this.snooze(details);
          } else {
            if (_this.is_caa) {
              _this.router.navigate(['/clinicianvideo/casemanagement/show', details.sessionId, 0, details.dbSessionId, 0, details.patientId, zipcode, county, name, details.appointmentId]);
            } else {
              _this.router.navigate(['/clinicianvideo/show', details.sessionId, 0, details.dbSessionId, 0, details.patientId, zipcode, county, name, details.appointmentId]);
            }
          }

        }
      });
    });

  }



  ConfirmReconnectingWaitingRoomByClinician(details) {
    const currentUrl = this.router.url;
    const _this = this;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': { lat: details.latitude, lng: details.longitude } }, function (results, status) {
      let zipcode = '';
      let county = '';
      if (results[1]) {
        for (let i = 0; i < results.length; i++) {
          if (results[i].types[0] === 'postal_code') {
            zipcode = results[i].address_components[0].long_name;
          }
          if (results[i].types[0] === 'administrative_area_level_2') {
            county = results[i].address_components[0].long_name;
          }
        }
      } else {
        zipcode = '';
        county = '';
      }
      _this.userService.getUserLicenceNumberandName().subscribe((data) => {
        if (data) {
          const name = data.firstName + ' ' + data.lastName;
          if (currentUrl.includes('clinicianvideo/casemanagement/show') || currentUrl.includes('clinicianvideo/show')) {
            _this.ClinicianSnoozeReconnectingCall(details);
          } else {
            if (_this.is_caa) {
              _this.router.navigate(['/clinicianvideo/casemanagement/show', details.sessionId, details.patientId, details.waitingRoomId, name, details.dbSessionId, zipcode, county]);
            } else {
              _this.router.navigate(['/clinicianvideo/show', details.sessionId, details.patientId, details.waitingRoomId, name, details.dbSessionId, zipcode, county]);
            }
          }

        }
      });
    });
  }


  toggleSidebar() {
    this.isSidenavActive = !this.isSidenavActive;
  }

  ClinicainCheckInWaitingRoomConfirm(details) {
    const currentUrl = this.router.url;
    // get county and zip
    const _this = this;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': { lat: details.latitude, lng: details.longitude } }, function (results, status) {
      let zipcode = '';
      let county = '';
      if (results[1]) {
        for (let i = 0; i < results.length; i++) {
          if (results[i].types[0] === 'postal_code') {
            zipcode = results[i].address_components[0].long_name;
          }
          if (results[i].types[0] === 'administrative_area_level_2') {
            county = results[i].address_components[0].long_name;
          }
        }
      } else {
        zipcode = '';
        county = '';
      }
      const session = {
        appointmentId: 0,
        patientId: details.patientId,
        clinicianId: details.clinicianId,
        anonymousUserId: 0,
        latitude: details.latitude,
        longitude: details.longitude,
        ipAddress: _this.userService.getIpaddress(),
        browserType: _this.userService.getBrowserType(),
        secretCode: null,
        uniqueId: '0',
        waitingroomId: details.waitingRoomId
      };
      _this.patientService.insertSession(session).subscribe((resp: any) => {
        _this.waitingRoomService.UpdateStartTime(details.waitingRoomId).subscribe(res => {
          _this.patientService.patientConnected(zipcode, county, resp.sessionId, details.clinicianId).subscribe((info: any) => {
            _this.userService.getUsername(details.patientId).subscribe((data) => {
              if (data) {
                const name = data.name;
                if (currentUrl.includes('clientvideo/show')) {
                  _this.CheckInCancel(details);
                } else {
                  _this.router.navigate(['/clientvideo/show', details.sessionId, name, resp.sessionId, details.waitingRoomId, details.clinicianId]);
                }

              }
            });
          });
        });
      });

    });
  }


  // reconnectin confirmation for participants side
  ConfirmReconnectingWaitingRoomByClient(details) {
    const currentUrl = this.router.url;
    // get county and zip
    const _this = this;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': { lat: details.latitude, lng: details.longitude } }, function (results, status) {
      let zipcode = '';
      let county = '';
      if (results[1]) {
        for (let i = 0; i < results.length; i++) {
          if (results[i].types[0] === 'postal_code') {
            zipcode = results[i].address_components[0].long_name;
          }
          if (results[i].types[0] === 'administrative_area_level_2') {
            county = results[i].address_components[0].long_name;
          }
        }
      } else {
        zipcode = '';
        county = '';
      }
      _this.patientService.patientConnected(zipcode, county, details.dbSessionId, details.clinicianId).subscribe((info: any) => {
        _this.userService.getUsername(details.patientId).subscribe((data) => {
          if (data) {
            const name = data.name;
            if (currentUrl.includes('clientvideo/show')) {
              _this.CheckInCancel(details);
            } else {
              _this.router.navigate(['/clientvideo/show', details.sessionId, name, details.dbSessionId, details.waitingRoomId, details.clinicianId]);
            }
          }
        });
      });
    });
  }

  clinicianCheckedInWaitingRoom() {

    this.apportisHubservice.connection.on('clinicianCheckedInWaitingRoom', (sessionId: any, patientId: any, clinicianId: any, clinicianName: any, waitingRoomId: any, roleName: any) => {
      this.confirmPopupInfo = new ConfirmPopupInfo();
      this.confirmPopupInfo.sessionId = sessionId;
      this.confirmPopupInfo.clinicianId = clinicianId;
      this.confirmPopupInfo.clinicianName = clinicianName;
      this.confirmPopupInfo.waitingRoomId = waitingRoomId;
      this.confirmPopupInfo.patientId = patientId;
      this.confirmPopupInfo.isReconnect = false;
      this.confirmPopupInfo.timerOff = false;
      this.role = roleName;
      if (this.apportisHubservice.isConnected) {
        navigator.geolocation.getCurrentPosition(this.getposition.bind(this), () => {
          this.getposition(null);
        }, { timeout: 3000 });
      } else {
        this.msgbox.alert(this.translateOrgSpecific.transform('ConnectionNotEstablishedMsg'), '');
      }
    });


    // reconnect session
    this.apportisHubservice.connection.on('clinicianReconnectWaitingRoom', (sessionId: any, patientId: any, clinicianId: any, clinicianName: any, waitingRoomId: any, dbSessionId: any, roleName: any) => {
      const currentUrl = this.router.url;
      this.confirmPopupInfo = new ConfirmPopupInfo();
      this.confirmPopupInfo.isReconnect = true;
      this.confirmPopupInfo.sessionId = sessionId;
      this.confirmPopupInfo.clinicianId = clinicianId;
      this.confirmPopupInfo.clinicianName = clinicianName;
      this.confirmPopupInfo.waitingRoomId = waitingRoomId;
      this.confirmPopupInfo.patientId = patientId;
      this.confirmPopupInfo.dbSessionId = dbSessionId;
      this.confirmPopupInfo.timerOff = false;
      this.role = roleName;
      if (this.apportisHubservice.isConnected) {
        navigator.geolocation.getCurrentPosition(this.getposition.bind(this), () => {
          this.getposition(null);
        }, { timeout: 3000 });
      } else {
        this.msgbox.alert(this.translateOrgSpecific.transform('ConnectionNotEstablishedMsg'), '');
      }
    });

  }


  getposition(position) {
    const info: any = {};
    let modalRef = null;
    this.setUpModel();
    if (position) {
      this.confirmPopupInfo.latitude = position.coords.latitude;
      this.confirmPopupInfo.longitude = position.coords.longitude;
    } else {
      this.confirmPopupInfo.latitude = 0;
      this.confirmPopupInfo.longitude = 0;
    }
    let isSessionSame = false;
    if (this.confirmPopupInfo.isReconnect) {
      isSessionSame = this.checkSameSession(this.confirmPopupInfo.dbSessionId, this.ClientLabel);
    }
    if (!isSessionSame) {
      modalRef = this.modalService.open(ConfirmBoxComponent, this.modalOption);
      if (this.confirmPopupInfo.isReconnect) {
        modalRef.componentInstance.data = { message: this.translateOrgSpecific.transform(this.role) + ' (' + this.confirmPopupInfo.clinicianName + ') has been trying to reconnect you to the waiting room. Do you want to check-in now?', user: this.ClientLabel, popupdata: this.confirmPopupInfo };
      } else {
        modalRef.componentInstance.data = { message: this.translateOrgSpecific.transform(this.role) + ' (' + this.confirmPopupInfo.clinicianName + ') has been checked in to the waiting room. Do you want to check-in now?', user: this.ClientLabel, popupdata: this.confirmPopupInfo };
      }

      this.modelReference.push({ model: modalRef, userId: this.confirmPopupInfo.clinicianId });

      modalRef.result.then((result) => {
        if (result) {
          this.modelReference = this.modelReference.filter(x => x.userId != result.data.clinicianId);
          if (result.data.isReconnect && result.result == this.translateOrgSpecific.transform('Accept')) {
            this.ConfirmReconnectingWaitingRoomByClient(result.data);
          } else if (!result.data.isReconnect && result.result == this.translateOrgSpecific.transform('Accept')) {
            this.ClinicainCheckInWaitingRoomConfirm(result.data);
          } else if (result.result == this.translateOrgSpecific.transform('Reject')) {
            this.CheckInCancel(result.data);
          } else if (result.result == this.translateOrgSpecific.transform('Timeout')) {
            this.patientService.noResponseFromClient(result.data.clinicianId, false).subscribe((resp: any) => {
            });
          }
        }

      });
    }
  }


  setUpModel() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.size = 'lg';
    this.modalOption.windowClass = 'msgpopupstyle';
  }


  geoPosition(position) {
    let modalRef = null;
    this.setUpModel();

    const info: any = {};
    if (position) {
      this.confirmPopupInfo.latitude = position.coords.latitude;
      this.confirmPopupInfo.longitude = position.coords.longitude;
    } else {
      this.confirmPopupInfo.latitude = 0;
      this.confirmPopupInfo.longitude = 0;
    }
    let isSessionSame = false;
    if (this.confirmPopupInfo.isReconnect) {
      isSessionSame = this.checkSameSession(this.confirmPopupInfo.dbSessionId, this.ClientLabel);
    }
    if (!isSessionSame) {
      modalRef = this.modalService.open(ConfirmBoxComponent, this.modalOption);
      if (this.confirmPopupInfo.isReconnect) {
        modalRef.componentInstance.data = { message: this.translateOrgSpecific.transform(this.role) + ' (' + this.confirmPopupInfo.clinicianName + ') has been trying to reconnect you for the appointment scheduled at ' + this.datepipe.transform(new Date(this.confirmPopupInfo.appointmentDt), 'MMM d, y h:mm:ss a') + '.Do you want to check-in now?', user: this.ClientLabel, popupdata: this.confirmPopupInfo };
      } else {
        modalRef.componentInstance.data = { message: this.translateOrgSpecific.transform('YouHaveAnAppointmentScheduledAt') + ' ' + this.datepipe.transform(new Date(this.confirmPopupInfo.appointmentDt), 'MMM d, y h:mm:ss a') + '.' + this.translateOrgSpecific.transform(this.role) + ' (' + this.confirmPopupInfo.clinicianName + ') has checked in. Do you want to check-in now?', user: this.ClientLabel, popupdata: this.confirmPopupInfo };
      }
      this.modelReference.push({ model: modalRef, userId: this.confirmPopupInfo.clinicianId });
      // after popup close
      modalRef.result.then((result) => {
        if (result) {
          this.modelReference = this.modelReference.filter(x => x.userId != result.data.clinicianId);

          if (result.data.isReconnect && result.result == this.translateOrgSpecific.transform('Accept')) {
            this.ClinicainReconnectConfirm(result.data);
          } else if (!result.data.isReconnect && result.result == this.translateOrgSpecific.transform('Accept')) {
            this.ClinicainCheckInConfirm(result.data);
          } else if (result.result == this.translateOrgSpecific.transform('Reject')) {
            this.rejectAppointment(result.data);
          } else if (result.result == this.translateOrgSpecific.transform('Timeout')) {
            this.patientService.noResponseFromClient(result.data.clinicianId, true).subscribe((resp: any) => {
            });
          }
        }
      });
    }
  }

  // cancel click for connecting and  reconnecting waiting room from participants
  CheckInCancel(details) {
    this.checkinService.leave_from_waiting_room(details.waitingRoomId, true).subscribe((data: any) => {
      if (data) {
        this.patientService.patientDeclinedAppointment(details.patientId, details.clinicianId).subscribe((info: any) => {
        });
      }
    });
  }

  rejectAppointment(details) {
    this.patientService.patientDeclinedAppointment(details.patientId, details.clinicianId).subscribe((info: any) => {

    });
  }

  ClinicainReconnectConfirm(details) {
    const currentUrl = this.router.url;
    // get county and zip
    const _this = this;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': { lat: details.latitude, lng: details.longitude } }, function (results, status) {
      let zipcode = '';
      let county = '';
      if (results[1]) {
        for (let i = 0; i < results.length; i++) {
          if (results[i].types[0] === 'postal_code') {
            zipcode = results[i].address_components[0].long_name;
          }
          if (results[i].types[0] === 'administrative_area_level_2') {
            county = results[i].address_components[0].long_name;
          }
        }
        _this.patientService.patientConnected(zipcode, county, details.dbSessionId, details.clinicianId).subscribe((info: any) => {
          _this.userService.getUsername(details.patientId).subscribe((data) => {
            if (data) {
              const name = data.name;
              if (currentUrl.includes('clientvideo/show')) {
                {
                  _this.rejectAppointment(details);
                }
              } else {
                _this.router.navigate(['/clientvideo/show', details.sessionId, name, details.dbSessionId, details.clinicianId]);
              }

            }
          });
        });
      } else {
        _this.patientService.patientConnected(zipcode, county, details.sessionId, details.clinicianId).subscribe((info: any) => {
          _this.userService.getUsername(details.patientId).subscribe((data) => {
            if (data) {
              const name = data.name;
              if (currentUrl.includes('clientvideo/show')) {
                _this.rejectAppointment(details);
              } else {
                _this.router.navigate(['/clientvideo/show', details.sessionId, name, details.dbSessionId, details.clinicianId]);
              }
            }
          });
        });
      }
    });
  }

  ClinicianSnoozeReconnectingCall(details) {
    this.patientService.clinicianSnoozeAppointment(details.patientId).subscribe((info: any) => {
    });
  }

  initializeMenu() {
    this.allMenuItems = [
            //  { label: this.translateOrgSpecific.transform('Home'), faIcon: 'fas fa-home', link: '/app/dashboard/', role: Role.SysAdmin + Role.OrgAdmin + Role.ClinicAdmin + Role.LocationAdmin },
            { label: this.translateOrgSpecific.transform('Home'), faIcon: 'fas fa-home', link: '/app/clinics', role: Role.ClinicAdmin + Role.LocationAdmin },
            { label: this.translateOrgSpecific.transform('Home'), faIcon: 'fas fa-home', link: '/app/organization/list', role: Role.SysAdmin },
            { label: this.translateOrgSpecific.transform('Home'), faIcon: 'fas fa-home', link: '/app/organization/info', role: Role.OrgAdmin },
      { label: this.translateOrgSpecific.transform('Home'), faIcon: 'fas fa-home', link: '/app/dashboard/patient', role: Role.Patient + Role.Participants },
      { label: this.translateOrgSpecific.transform('Home'), faIcon: 'fas fa-home', link: '/app/dashboard/clinician', role: Role.CaseManager + Role.Clinician },
      { label: this.translateOrgSpecific.transform('Home'), faIcon: 'fas fa-home', link: '/app/dashboard/socialworker', role: Role.SocialWorker },
      { label: this.translateOrgSpecific.transform('Home'), faIcon: 'fas fa-home', link: '/app/dashboard/family', role: Role.Family },
      { label: this.translateOrgSpecific.transform('Home'), faIcon: 'fas fa-home', link: '/app/dashboard/staff', role: Role.Staff },
      { label: this.translateOrgSpecific.transform('Organizations'), faIcon: 'fas fa-sitemap', link: '/app/organization/list', role: Role.SysAdmin },
      { label: this.translateOrgSpecific.transform('ModuleConfiguration'), faIcon: 'fas fa-cogs', link: '/app/configuration/list', role: Role.SysAdmin },
      { label: this.translateOrgSpecific.transform('MyOrganization'), faIcon: 'fas fa-sitemap', link: '/app/organization/info', role: Role.OrgAdmin },
      { label: this.translateOrgSpecific.transform('Clinics'), faIcon: 'fas fa-map-marker', link: '/app/clinics', role: Role.OrgAdmin + Role.ClinicAdmin },
      { label: this.translateOrgSpecific.transform('ClinicsAvailability'), faIcon: 'fas fa fa-calendar-alt', link: '/app/clinichour/clinicHours', role: Role.OrgAdmin + Role.ClinicAdmin },
      { label: this.translateOrgSpecific.transform('Users'), faIcon: 'fas fa-users', link: '/app/user', role: Role.SysAdmin + Role.OrgAdmin + Role.ClinicAdmin + Role.LocationAdmin },
      { label: this.translateOrgSpecific.transform('Availability'), faIcon: 'fas fa fa-calendar-alt', link: '/app/availability', role: Role.Clinician + Role.CaseManager + Role.SocialWorker },
      { label: this.translateOrgSpecific.transform('Appointments'), faIcon: 'fas fa fa-calendar-check', link: '/app/appointment/list', role: Role.Clinician + Role.CaseManager + Role.SocialWorker },
      { label: this.translateOrgSpecific.transform('Appointments'), faIcon: 'fas fa fa-calendar-check', link: '/app/appointment/clinicadminlist', role: Role.ClinicAdmin },
      { label: this.translateOrgSpecific.transform('Appointments'), faIcon: 'fas fa fa-calendar', link: '/app/appointment/patientlist', role: Role.Patient + Role.Participants },
      { label: this.translateOrgSpecific.transform('WaitingRoom'), faIcon: 'fas fa-user-friends', link: '/app/waitingroom', role: Role.Clinician + Role.CaseManager + Role.SocialWorker },
      { label: this.translateOrgSpecific.transform('Families'), faIcon: 'fas fa-home', link: '/app/family/list', role: Role.Clinician + Role.OrgAdmin + Role.ClinicAdmin + Role.SocialWorker },
      { label: this.translateOrgSpecific.transform('Clients'), faIcon: 'fas fa-users', link: '/app/patient/list', role: Role.Clinician + Role.OrgAdmin + Role.ClinicAdmin + Role.CaseManager + Role.LocationAdmin + Role.SocialWorker },
    ];
    if (this.orgName == "Claymont City Schools") {
      this.allMenuItems.push(
        { label: this.translateOrgSpecific.transform('TuffBag'), faIcon: 'fa fa-briefcase', link: '/app/tuffbag/list', role: Role.Clinician + Role.OrgAdmin + Role.Patient + Role.CaseManager + Role.Family + Role.SocialWorker },
        {
          label: this.translateOrgSpecific.transform('Tools'), faIcon: 'fas fa-tools', role: Role.Patient + Role.Staff
          , items: [
            { label: this.translateOrgSpecific.transform('MiddleGradeForm'), faIcon: 'fab fa-wpforms', link: '/app/grade-6-8/list', role: Role.Clinician + Role.Patient + Role.OrgAdmin + Role.Family + Role.Staff + Role.SocialWorker },
            { label: this.translateOrgSpecific.transform('High1GradeForm'), faIcon: 'fab fa-wpforms', link: '/app/grade-9-11/list', role: Role.Clinician + Role.OrgAdmin + Role.Family + + Role.Patient },
            { label: this.translateOrgSpecific.transform('High2GradeForm'), faIcon: 'fab fa-wpforms', link: '/app/grade-10-12/list', role: Role.Clinician + Role.OrgAdmin + Role.Family + + Role.Patient },

          ]
        },
        {
          label: this.translateOrgSpecific.transform('Tools'), faIcon: 'fas fa-tools', role: Role.Clinician + Role.OrgAdmin + Role.Family + Role.SocialWorker
          , items: [
            { label: this.translateOrgSpecific.transform('PrimaryElementaryGradeForm'), faIcon: 'fab fa-wpforms', link: '/app/grade-PK-3/list', role: Role.Clinician + Role.OrgAdmin + Role.Family + Role.SocialWorker },
            { label: this.translateOrgSpecific.transform('IntermediateGradeForm'), faIcon: 'fab fa-wpforms', link: '/app/grade-4-5/list', role: Role.Clinician + Role.OrgAdmin + Role.Family + Role.SocialWorker },
            { label: this.translateOrgSpecific.transform('MiddleGradeForm'), faIcon: 'fab fa-wpforms', link: '/app/grade-6-8/list', role: Role.Clinician + Role.OrgAdmin + Role.Family + Role.SocialWorker },
            { label: this.translateOrgSpecific.transform('High1GradeForm'), faIcon: 'fab fa-wpforms', link: '/app/grade-9-11/list', role: Role.Clinician + Role.OrgAdmin + Role.Family + Role.SocialWorker },
            { label: this.translateOrgSpecific.transform('High2GradeForm'), faIcon: 'fab fa-wpforms', link: '/app/grade-10-12/list', role: Role.Clinician + Role.OrgAdmin + Role.Family + Role.SocialWorker },
          ]
        },
      );
    }
    this.allMenuItems.push(
      { label: this.translateOrgSpecific.transform('Announcements'), faIcon: 'fas fa fa-bullhorn', link: '/app/announcement', role: Role.OrgAdmin + Role.ClinicAdmin },
      { label: this.translateOrgSpecific.transform('AppointmentTypes'), faIcon: 'fas fa-map-marker', link: '/app/appointmenttype/list', role: Role.SysAdmin + Role.OrgAdmin + Role.ClinicAdmin },
      { label: this.translateOrgSpecific.transform('WaitingRoom'), faIcon: 'fas fa-user-check', link: this.is_caa ? '/app/checkin/checkin-casemangmnt' : '/app/checkin', role: Role.Patient + Role.Participants },
      { label: this.translateOrgSpecific.transform('ResourceCategories'), faIcon: 'fas fa-file', link: '/app/resourcescategory', role: Role.OrgAdmin + Role.SysAdmin },
      { label: this.translateOrgSpecific.transform('Resources'), faIcon: 'fas fa-copy', link: '/app/resources', role: Role.OrgAdmin + Role.ClinicAdmin + Role.Clinician + Role.Patient + Role.CaseManager + Role.Participants + Role.Family + Role.Staff + Role.SysAdmin + Role.SocialWorker },
      { label: this.translateOrgSpecific.transform('MoveResources'), faIcon: 'fas fa-file-export', link: '/app/moveresource', role: Role.SysAdmin },
      { label: this.translateOrgSpecific.transform('EmailConfiguration'), faIcon: 'fas fa-envelope', link: '/app/emailConfig/list', role: Role.SysAdmin },
      { label: this.translateOrgSpecific.transform('ImportUsers'), faIcon: 'fas fa-upload', link: '/app/upload', role: Role.OrgAdmin },

    );

    if (this.is_enable_covid_tracking) {
      this.allMenuItems.push(
        { label: this.translateOrgSpecific.transform('CovidTrackingMenu'), faIcon: 'fas fa-clipboard-list', link: '/app/covidtracking/info', role: Role.Clinician + Role.CaseManager + Role.SocialWorker },
      );
    }
    if (this.is_caa) {
      this.allMenuItems.push({ label: this.translateOrgSpecific.transform('FoodandShelters'), faIcon: 'fas fa-file-export', link: '/app/food-shelters', role: Role.OrgAdmin + Role.ClinicAdmin },
        { label: this.translateOrgSpecific.transform('CountyEmergencyInfo'), faIcon: 'fas fa-file-export', link: '/app/county-emergency-info', role: Role.OrgAdmin + Role.ClinicAdmin },
      );

      this.allMenuItems.push({
        label: this.translateOrgSpecific.transform('Reports'), faIcon: 'fas fa-chart-bar', role: Role.CaseManager + Role.LocationAdmin + Role.OrgAdmin + Role.ClinicAdmin
        , items: [
          {
            label: 'Cases', faIcon: 'fas fa-list-alt ', link: '/app/report/caaCaseReport', role: Role.CaseManager + Role.LocationAdmin + Role.OrgAdmin + Role.ClinicAdmin
          },
          { label: 'Age & County', faIcon: 'fas fa-address-card', link: '/app/report/caaReport', role: Role.CaseManager + Role.LocationAdmin + Role.OrgAdmin + Role.ClinicAdmin },
          { label: 'Visits', faIcon: 'fa fa-bars', link: '/app/report/visitReport', role: Role.CaseManager + Role.LocationAdmin + Role.OrgAdmin + Role.ClinicAdmin }
        ]
      });
    } else {
      this.allMenuItems.push({ label: this.translateOrgSpecific.transform('Reports'), faIcon: 'fas fa-chart-bar', link: '/app/report/list', role: Role.OrgAdmin + Role.ClinicAdmin + Role.SysAdmin });
    }

    this.allMenuItems.push({
        label: "Open Screen to Action",
        faIcon: "fas fa-external-link-alt",
        role: Role.OrgAdmin + Role.ClinicAdmin + Role.SysAdmin,
        onSelected: () => {
          console.log("jwtToken clicked");

          this.userService.launchApp().subscribe((data) => {
            if (data) {
              console.log(data);

              window.open(
               `https://demo.screentoaction.com/auth/jwt-login?jwt=${data?.['jwtToken']}`
              )
              
            }
          });
        },
      });

    //  this.allMenuItems.push({
    //   label: "Reports (Screen to Action)",
    //   faIcon: "fas fa-chart-area",
    //   role: Role.OrgAdmin + Role.ClinicAdmin + Role.SysAdmin,
    //   link: '/app/report/s2aReport',
      
    // });
    
    this.allMenuItems = this.allMenuItems.slice();
  }


  public ClinicainCheckInConfirm(details) {
    const currentUrl = this.router.url;
    // get county and zip
    const _this = this;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': { lat: details.latitude, lng: details.longitude } }, function (results, status) {
      let zipcode = '';
      let county = '';
      if (results[1]) {
        for (let i = 0; i < results.length; i++) {
          if (results[i].types[0] === 'postal_code') {
            zipcode = results[i].address_components[0].long_name;
          }
          if (results[i].types[0] === 'administrative_area_level_2') {
            county = results[i].address_components[0].long_name;
          }
        }
      } else {
        zipcode = '';
        county = '';
      }
      const session = {
        appointmentId: details.appointmentId,
        patientId: details.patientId,
        clinicianId: details.clinicianId,
        anonymousUserId: 0,
        latitude: details.latitude,
        longitude: details.longitude,
        ipAddress: _this.userService.getIpaddress(),
        browserType: _this.userService.getBrowserType(),
        secretCode: null,
        uniqueId: 0
      };
      _this.patientService.insertSession(session).subscribe((res: any) => {
        _this.patientService.patientConnected(zipcode, county, res.sessionId, details.clinicianId).subscribe((info: any) => {
          _this.userService.getUsername(details.patientId).subscribe((data) => {
            if (data) {
              const name = data.name;
              if (currentUrl.includes('clientvideo/show')) {
                _this.rejectAppointment(details);
              } else {
                _this.router.navigate(['/clientvideo/show', details.sessionId, name, res.sessionId, details.clinicianId]);
              }
            }
          });
        });
      });
    });
  }

}
